import React, { memo, useEffect, useState } from "react";
import imageFallback from "assets/png/imageFallback.jpg"

const Image = ({ src, alt, className, style, fallback = imageFallback, ...props }) => {
  const [imgSrc, setImgSrc] = useState(src);

  const handleError = () => {
    setImgSrc(fallback);
  };
  
  useEffect(()=>{
    setImgSrc(src)
  }, [src])
  
  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      style={{
        filter: "blur(2px)",
        transition: "filter 0.3s ease-in-out",
        ...style,
      }}
      onError={handleError}
      onLoad={(e) => (e.target.style.filter = "none")}
      {...props}
    />
  );
};

export default memo(Image);
